export default __webpack_public_path__ + "static/media/zoom-in.6fb4f342.svg";